'use client';

import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="w-full border-t mt-12 py-4 px-8">
      <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-between gap-4 text-sm text-muted-foreground">
        <div>
          © {new Date().getFullYear()} myInstantAPI LLC | Commit: {process.env.NEXT_PUBLIC_COMMIT?.slice(0,7) || 'unknown'}
        </div>
        <div className="flex gap-4">
          <Link href="/privacy" className="hover:text-primary">Privacy Policy</Link>
          <Link href="/terms" className="hover:text-primary">Terms of service</Link>
        </div>
      </div>
    </footer>
  );
}